import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced = true;
const state = {
    // 選擇欲辦理變更的保單
    policy: {},
    // 該保單的類別
    policyKindInvestment: '',
    changeItemsResult: {},
};

export const policy = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
